import { z } from 'zod';
export const OmniFieldSchema = z
    .string()
    .min(1)
    .describe('Field identifier returned by field discovery. Discovery does not guarantee query access.');
export const OmniFieldDefinitionSchema = z.strictObject({
    name: OmniFieldSchema,
    kind: z.enum(['dimension', 'measure', 'filter']),
    dataType: z.string().min(1).describe('Analytical field type, not a JavaScript value type.'),
    label: z.string().optional(),
    description: z.string().optional(),
    timeZoneMode: z
        .enum(['convertToQueryTimeZone', 'preserveDatabaseTimeZone'])
        .default('convertToQueryTimeZone')
        .describe('Whether date/time values use the query timezone or retain their stored timezone.'),
});
//# sourceMappingURL=fields.js.map